import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ApiService } from 'src/app/api.service';
import { AuthenticationService } from 'src/app/_services';
import { SecurityDocument } from 'src/app/shared/models/SecurityDocument';
import { State } from 'src/app/shared/models/State';
import * as FileSaver from 'file-saver';
import autoTable from 'jspdf-autotable';
import { TranslateRelLabelVO } from 'src/app/shared/models/TranslateRelLabelVO';
import { CategoryLan } from 'src/app/shared/models/CategoryLan';
import { Store } from 'src/app/shared/models/Store';
import { LstStoreResponse } from 'src/app/shared/models/lstStoreResponse';
import { DatePipe } from '@angular/common';
import { TovpilUtilsService } from 'src/app/utils/tovpil-utils.service';
import { TovpilFilesService } from 'src/app/utils/tovpil-files.service';
import { TovpilLanguageService } from 'src/app/utils/tovpil-language.service';

@Component({
  selector: 'app-purch-itm-dwn-list',
  templateUrl: './purch-itm-dwn-list.component.html',
  styleUrls: ['./purch-itm-dwn-list.component.scss'],
  providers: [MessageService, ConfirmationService]
})
export class PurchItmDwnListComponent implements OnInit {
  currentUser: any;
  profileUser: any;
  security: SecurityDocument;
  lstItems: any[];
  selectedChurch: any;
  datePipe: DatePipe = new DatePipe('en-US');


  listZones: Store[];
  selectedZone: Store;
  listNatio: Store[];
  selectedNatio: Store;
  listLocal: Store[];
  selectedLocal: Store;
  listStores: string[] = [];
  isPropertyActive: boolean;
  isMongoDisabled: boolean;

  blocked: boolean = false;
  token: string;

  dataParent: any;

  lstRespTranslate: TranslateRelLabelVO[];

  translations: Record<string, string> = {};

  constructor(private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private apiService: ApiService,
    private router: Router,
    private route: ActivatedRoute,
    private authenticationService: AuthenticationService,
    private tovpilUtils: TovpilUtilsService,
    private filesService: TovpilFilesService,
    private translationService: TovpilLanguageService) {
    const navigation = this.router.getCurrentNavigation();
    this.dataParent = navigation.extras.state as any;
    if (this.dataParent) {
      this.loadInitialData();
    }

  }

  ngOnInit(): void {
    this.route.queryParams
      .subscribe(
        params => {
          this.token = params.token;
        });
    this.getSecurity();
  }


  openNewChurch() {
    this.openRecordDetail(null);
  }

  openRecordDetail(record: any) {
    let obj = {
      record: record,
      security: this.security,
      listStores: this.listStores,
      profileUser: this.profileUser,
      selectedZone: this.selectedZone != null ? this.selectedZone : null,
      selectedNatio: this.selectedNatio != null ? this.selectedNatio : null,
      selectedLocal: this.selectedLocal != null ? this.selectedLocal : null
    }

    let navigationExtras: NavigationExtras = {
      state: JSON.parse(JSON.stringify(obj))
    }

    this.router.navigate(['/materials/purchItmDwnDetail'], navigationExtras);
  }

  goBack() {
    window.close();
  }

 /**
  * The function `getSecurity` retrieves security data, performs various asynchronous operations, and
  * sets a button disabled state based on security level.
  */
  async getSecurity() {
    this.listZones = [];
    this.listNatio = [];
    this.listLocal = [];
    const data = await this.apiService.findSecurityById({ "id": this.token });
    this.security = data;
    console.log(this.security);
    await this.findSupStoreRelationship();
    await this.getValidStores();
    await this.getGuideProfileServices();
    this.getTranslatedLabels();
    this.getPropertiesValue();

    if (this.security.levelId == 'I') {
      this.isPropertyActive = true;
    }
    else {
      this.isPropertyActive = false;
    }
  }


  /**
   * This TypeScript function asynchronously retrieves the profile of a guide based on their ID.
   */
  async getGuideProfileServices() {
    if (this.security.guideId) {
      const data = await this.apiService.getGuideProfile({ guideId: this.security.guideId });
      this.profileUser = data;
    }
  }

  async getPropertiesValue() {
    let res = await this.apiService.getPropertyValue({
      "id": "audio.purchasing.activated"
    });

    if (res == true) {
      this.isMongoDisabled = false;
    } else {
      this.isMongoDisabled = true;
    }
  }


  exportExcel() {
    if (this.lstItems === null) {
      this.messageService.add({
        severity: 'error',
        summary: 'No existe información para procesar',
        life: 3000
      });
    } else if (this.lstItems.length < 1) {
      this.messageService.add({
        severity: 'error',
        summary: 'La lista está vacía',
        life: 3000
      });
    } else {

      const filteredJSON = this.lstItems.map((item) => {
        return {
          "NOMBRE": item.guidefullName || 'S/N',
          "DESCRIPCION": item.itemDescr || 'S/N',
          "LENGUAJE": item.purchItmDwn.id ? (item.purchItmDwn.id.language || 'S/N') : 'S/N',
          "EMAIL": item.guideEmail || 'S/N',
          "FECHA_COMPRA": item.purchItmDwn ? (this.formatDate(item.purchItmDwn.purchDate) || 'S/N') : 'S/N',
          "FECHA_FINAL": item.purchItmDwn ? (this.formatDate(item.purchItmDwn.endDate) || 'S/N') : 'S/N',
          "ESTATUS_DESCUENTO": item.prchStatusDesc || 'S/N'
        };
      });


      this.filesService.tovpilExportXLSX(filteredJSON, 'listPurchItem_');

    }
  }



  exportPdf() {
    if (this.lstItems === null) {
      this.messageService.add({
        severity: 'error',
        summary: 'No existe información para procesar',
        life: 3000
      });
    } else if (this.lstItems.length < 1) {
      this.messageService.add({
        severity: 'error',
        summary: 'La lista está vacía',
        life: 3000
      });
    } else {

      const filteredJSON = this.lstItems.map((item) => {
        return {
          "NOMBRE": item.guidefullName || 'S/N',
          "DESCRIPCION": item.itemDescr || 'S/N',
          "LENGUAJE": item.purchItmDwn.id ? (item.purchItmDwn.id.language || 'S/N') : 'S/N',
          "EMAIL": item.guideEmail || 'S/N',
          "FECHA_COMPRA": item.purchItmDwn ? (this.formatDate(item.purchItmDwn.purchDate) || 'S/N') : 'S/N',
          "FECHA_FINAL": item.purchItmDwn ? (this.formatDate(item.purchItmDwn.endDate) || 'S/N') : 'S/N',
          "ESTATUS_DESCUENTO": item.prchStatusDesc || 'S/N'
        };
      });



      const keysArray = filteredJSON.map((item) => Object.keys(item));
      const valuesArray = filteredJSON.map((item) => Object.values(item));

      this.filesService.tovpilExportPDF(keysArray[0], valuesArray, 'listPurchItem_');

    }
  }

  search() {

  }


  deleteRecord(itm: any) {
    this.confirmationService.confirm({
      message: '¿ ' + this.translations.lbl_are_you_sure + ' ' + this.translations.lbl_delete + ' ?',
      header: itm.itemDescr + " /" + itm.guidefullName + " Idioma: " + itm.purchItmDwn.id.language,
      icon: 'pi pi-exclamation-triangle',
      acceptButtonStyleClass: "p-button-danger",
      rejectButtonStyleClass: "p-button-info",
      accept: () => {
        this.deleteRecordService(itm);
      }
    });
  }

  deleteRecordService(itm: any) {
    this.apiService.deletePurchItmDwn(itm.purchItmDwn).then(
      data => {
        this.findPurchItmDwnByStore();
      });

  }


  /**
   * The function `getTranslatedLabels` is an asynchronous function that retrieves translated labels from
   * a translation service and sets them in the `translations` variable, and then calls another function
   * .
   */
  async getTranslatedLabels() {
    // this.blocked = true;
    const language = this.security.language || null;
    const region = this.security.region || null;

    try {
      await this.translationService.getTranslatedLabels(language, region);
      this.translations = this.translationService.getLabels();
    } catch (error) {
      console.error(
        "An error occurred while getting translated labels:",
        error
      );
      // this.messageService.add({ severity: 'warn', summary: 'Error', detail: `Error: ${this.translations.lbl_translation} ${this.translations.lbl_language}` });
    }
    // this.blocked = false;
  }


  getChildStores(selStr: string, level: string) {
    let res: LstStoreResponse;
    this.apiService.getListStore(selStr, "", "").then(
      data => {
        res = data;
        if (level == 'L') {
          this.listLocal = res.lstStore;
          if (this.dataParent) {
            this.selectedLocal = this.dataParent.selectedLocal;
          }
        } else if (level == 'N') {
          this.listNatio = res.lstStore;
          if (this.dataParent) {
            this.selectedNatio = this.dataParent.selectedNatio;
            this.loadLocals(null);
          }
        } else if (level == 'Z') {
          if (this.listZones == null || this.listZones.length == 0) {
            this.listZones = res.lstStore;
          }
        }
      });
  }


  loadLocals(event) {

    if (this.selectedNatio != null && this.selectedNatio.storeId != null) {
      this.getChildStores(this.selectedNatio.storeId, 'L');
    }
  }


  loadNatios(event) {
    if (this.selectedZone != null && this.selectedZone.storeId != null) {
      this.getChildStores(this.selectedZone.storeId, 'N');
    }
  }

  loadRecords(event) {
    this.getValidStores();
  }

  getValidStores() {
    let supStoreId: string;
    if (this.selectedLocal != null && this.selectedLocal.storeId != null) {
      supStoreId = this.selectedLocal.storeId;
    } else if (this.selectedNatio != null && this.selectedNatio.storeId != null) {
      supStoreId = this.selectedNatio.storeId;
    } else if (this.selectedZone != null && this.selectedZone.storeId != null) {
      supStoreId = this.selectedZone.storeId;
    } else {
      supStoreId = "0000000002";
    }
    this.apiService.getDependetLocalStores(
      {
        "storeId": supStoreId
      }
    ).then(
      data => {
        this.listStores = data;
        this.findPurchItmDwnByStore();
      });
  }

  findPurchItmDwnByStore() {
    this.blocked = true;
    const body = { lstStr: this.listStores }
    this.apiService.findPurchItmDwnByStore(body).then(
      data => {
        this.lstItems = data;
        this.blocked = false;
      }).catch(error => {
        this.blocked = false;
        console.error(error ? error : "error findPurchItmDwnByStore");
        this.messageService.add({ key: "tst", severity: 'error', summary: error ? error : "error findPurchItmDwnByStore", detail: " - " + error + "/", life: 3000 });
      });
  }

  loadInitialData() {
    this.selectedZone = this.dataParent.selectedZone;
    this.loadNatios(null);
  }

  /**
    * This function formats a given date string into a specific format using the datePipe module in
    * TypeScript.
    * @param {string} dateString - A string representing a date in any valid format (e.g. "2021-10-15" or
    * "Oct 15, 2021").
    * @returns The function `formatDate` is returning a formatted date string in the format of
    * 'dd-MM-yyyy'. The input parameter `dateString` is being passed to the `datePipe.transform` method to
    * format the date. The formatted date string is then returned by the function.
  */
  formatDate(dateString: string) {
    const formattedDate = this.datePipe.transform(this.tovpilUtils.convertStringToDate(dateString), 'yyyy-MM-dd');
    return formattedDate;
  }
  async findSupStoreRelationship() {
    await this.apiService.findSupStoreRelationship({
      "storeId": this.security.storeId
    }).then(
      data => {
        if (data) {
          this.selectedLocal = data.strLocal;
          this.selectedNatio = data.strNatio;
          this.selectedZone = data.strZone;

          if (this.security.levelId == 'L') {
            this.listZones.push(this.selectedZone);
            this.listNatio.push(this.selectedNatio);
            this.listLocal.push(this.selectedLocal);
          } else if (this.security.levelId == 'N') {
            this.listZones.push(this.selectedZone);
            this.listNatio.push(this.selectedNatio);
            this.getChildStores(this.selectedNatio.storeId, 'L');
          } else if (this.security.levelId == 'Z') {
            this.listZones.push(this.selectedZone);
            this.getChildStores(this.selectedZone.storeId, 'N');
          } else if (this.security.levelId == 'I') {
            this.getChildStores('0000000002', 'Z');
          } else {
          }
        }
      });
  }
}
